import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-email-sent-dialog',
  templateUrl: './email-sent-dialog.component.html',
  styleUrls: ['./email-sent-dialog.component.scss'],
})
export class EmailSentDialogComponent {
  countdown = 20;
  countdownCompleted = false;
  intervalId: any;
  isResending = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { email: string },
    private _auth: AuthServiceLocal,
    private _snackBar: MatSnackBar
  ) {
    this.startCountdown();
  }

  startCountdown() {
    this.countdownCompleted = false;
    this.countdown = 20;

    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.intervalId);
        this.countdownCompleted = true;
      }
    }, 1000);
  }

  onResendEmail() {
    if (!this.data.email) return;

    this.isResending = true;

    const payload = { email: this.data.email };

    this._auth.onForgotpassword(payload).subscribe({
      next: (res: any) => {
        this._snackBar.open('Password reset email sent again.', 'OK', {
          duration: 3000,
        });
        this.isResending = false;
        this.startCountdown();
      },
      error: () => {
        this._snackBar.open('Failed to resend email. Try again later.', 'OK', {
          duration: 3000,
        });
        this.isResending = false;
      },
    });
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
